import { ManufacturerPrice } from '../manufacturer/manufacturer-models';
import { Region } from '../region/region-models';
import { Country } from '../country/country-models';

export interface Product {
  code?: number;
  name?: string;
  manufacturername?: string;
  catalogs?: ProductCatalog[];
  prices?: ManufacturerPrice[];
  regions?: Region[];
  countries?: Country[];
  creationdate?: string;
  modificationdate?: string;
  samples?: ProductSample[];
  props?: { [name: string]: any };
}

export enum ProductStatus {
  Normal = 'normal',
  Removed = 'removed'
}

export interface ProductSample {
  url?: string;
  creationdate: string;
}

export interface ProductCatalog {
  id?: number;
  catalogname?: string;
  parent?: number;
  rank?: number;
  productcount?: number;
  props?: { [name: string]: any };
}

export interface ProductCompany {
  name: string;
  productcount: number;
}
